;(function() {
  'use strict'

  Controller.$inject = ["$element"];
  angular.module('app.core').component('searchEvidence', {
    controller: Controller,
    templateUrl: 'search-evidence.html',
    bindings: {
      match: '<',
    },
  })

  /* @ngInject */
  function Controller($element) {
    $element.addClass('search-evidence')
  }
})()
